import React, {PureComponent} from 'react';
import './PayResultTips.scss';

export default class PayResultTips extends PureComponent {
    
    render() {
        var oInfo = this.props.oTipsInfo;
        return (
            <div className={ "m-tips--pay " + (oInfo.type || 'suc') }>
                <div className="ico"></div>
                <p className="txt"><span className="note">{oInfo.note || ''}</span>{oInfo.txt}</p>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/common/components/pop-tips/PayResultTips.jsx